import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './lang/zh'
import viVN from './lang/vi'
import en from 'element-ui/lib/locale/lang/en'
import zhCNElement from 'element-ui/lib/locale/lang/zh-CN'
import viElement from 'element-ui/lib/locale/lang/vi'
import ElementLocale from 'element-ui/lib/locale'

// 必须先安装 VueI18n 插件
Vue.use(VueI18n)

// 合并自定义语言和 Element UI 语言
const messages = {
  'zh-CN': { ...zhCNElement, ...zhCN },
  'vi': { ...viElement, ...viVN },
  'en': { ...en },
}

// 获取浏览器语言或本地存储的语言设置
function getLanguage() {
  const storedLang = process.env.VUE_APP_LANG || 'zh-CN'
  if (storedLang) {
    return storedLang
  }
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.startsWith('vi')) {
    return 'vi'
  }
  return 'zh-CN'
}

// 获取初始语言
const initialLang = getLanguage()

// 设置初始 Element UI 语言
if (initialLang === 'vi') {
  ElementLocale.use(viElement)
} else if (initialLang === 'en') {
  ElementLocale.use(en)
} else {
  ElementLocale.use(zhCNElement)
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: initialLang,
  messages,
})

// 切换语言的方法
export function setLanguage(lang) {
  if (messages[lang]) {
    i18n.locale = lang
    localStorage.setItem('language', lang)
    // 切换 Element UI 语言
    ElementLocale.use(lang === 'zh-CN' ? zhCNElement : (lang === 'vi' ? viElement : en))
    return true
  }
  return false
}

export default i18n
